import { Component } from '@angular/core';

@Component({
    selector: 'app-chatbot-modal',
    templateUrl: './chatbot-modal.component.html',
    styleUrls: ['./chatbot-modal.component.scss'],
    standalone: true,
})
export class ChatbotModalComponent {
    closeModal() {
        localStorage.setItem('modal', 'false');
        let modal: any = document.querySelector('#myModal');
        modal.style.display = 'none';
    }
}
